export type EncounterCheckoutPusherPayload = {
  status: string
  message: string
}

export type EncounterCheckoutResolution = 'success' | 'failure' | 'pending'

const normalizeStatus = (status: string): string =>
  status
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_')

const SUCCESS_STATUSES: ReadonlySet<string> = new Set(['succeeded'])

const PENDING_STATUSES: ReadonlySet<string> = new Set(['accepted'])

const FAILURE_STATUSES: ReadonlySet<string> = new Set([
  'rejected',
  'failed',
  'cancelled',
  'canceled',
  'timed_out',
])

export const classifyEncounterCheckoutStatus = (status: string): EncounterCheckoutResolution => {
  const normalized = normalizeStatus(status)
  if (SUCCESS_STATUSES.has(normalized)) return 'success'
  if (PENDING_STATUSES.has(normalized)) return 'pending'
  if (FAILURE_STATUSES.has(normalized)) return 'failure'
  return 'failure'
}

export const parseEncounterCheckoutPayload = (
  raw: unknown,
): EncounterCheckoutPusherPayload | null => {
  let candidate: unknown = raw

  if (typeof raw === 'string') {
    try {
      candidate = JSON.parse(raw)
    } catch {
      return null
    }
  }

  if (!candidate || typeof candidate !== 'object') {
    return null
  }

  const obj = candidate as Record<string, unknown>
  const status = typeof obj.status === 'string' ? obj.status : ''
  const message = typeof obj.message === 'string' ? obj.message : ''

  if (!status) {
    return null
  }

  return { status, message }
}
